import { Button, CompareReportsModal } from '@/components';
import { tariffDisplayData } from '@/config';
import { useTranslation } from 'react-i18next';
import { useModal, useDevice } from '@/hooks';

import styles from './CompareTariffsHeader.module.sass';

const CompareTariffsHeader = () => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const {
    isOpen: isOpenCompareReportsModal,
    onOpenModal: handleOpenCompareReportsModal,
    onCloseModal: handleCloseCompareReportsModal,
  } = useModal();

  const handleClick = () => {
    handleOpenCompareReportsModal();
  };

  return (
    <div className={styles.header}>
      <div className={styles.col}>
        <div className={styles.title}>{tariffDisplayData.lite.title}</div>
      </div>

      <div className={styles.col}>
        <div className={styles.title}>{tariffDisplayData.pro.title}</div>
        <Button
          type="secondary"
          corner="rect"
          size={isMobile ? 's' : 'm'}
          fullwidth
          onClick={handleClick}
        >
          {t('translation.become_pro')}
        </Button>
      </div>

      <div className={styles.col}>
        <div className={styles.title}>{tariffDisplayData.proPlus.title}</div>
        <Button
          type="secondary"
          corner="rect"
          size={isMobile ? 's' : 'm'}
          fullwidth
          onClick={handleClick}
        >
          {t('translation.become_pro_plus')}
        </Button>
      </div>
      <CompareReportsModal
        isOpen={isOpenCompareReportsModal}
        onClose={handleCloseCompareReportsModal}
      />
    </div>
  );
};

export default CompareTariffsHeader;
